import { render, staticRenderFns } from "./articleCategoryHide.vue?vue&type=template&id=527b9cf6&scoped=true&"
import script from "./articleCategoryHide.vue?vue&type=script&lang=js&"
export * from "./articleCategoryHide.vue?vue&type=script&lang=js&"
import style0 from "./articleCategoryHide.vue?vue&type=style&index=0&id=527b9cf6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527b9cf6",
  null
  
)

export default component.exports